import { render, staticRenderFns } from "./DataCollapseHes.vue?vue&type=template&id=0d39b844&scoped=true"
import script from "./DataCollapseHes.vue?vue&type=script&lang=js"
export * from "./DataCollapseHes.vue?vue&type=script&lang=js"
import style0 from "./DataCollapseHes.vue?vue&type=style&index=0&id=0d39b844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d39b844",
  null
  
)

export default component.exports